/* Meubelhunter — redesign PDP: live updates bij variantwissel
   (prijs, van-prijs, korting%, iDEAL-termijn, levertijd/voorraad) + scroll naar reviews. */
(function () {
  'use strict';
  var root = document.querySelector('[data-mhp]');
  if (!root) return;

  var map = {};
  var mapEl = document.querySelector('[data-mhp-variants]');
  if (mapEl) { try { map = JSON.parse(mapEl.textContent); } catch (e) {} }

  /* ---------- Aantal-stepper (alleen bij variant-foto-producten) ----------
     Bij producten met variant-eigen foto's ontbreekt Empire's [data-product-gallery];
     Empire's ProductDetails crasht daardoor bij het bouwen van de ProductGallery en
     bindt de +/- knoppen NIET. Op die producten binden we de stepper zelf.
     Bij de rest laat Empire de stepper met rust (geen dubbele binding). */
  if (root.hasAttribute('data-mhp-selfqty')) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-plus], [data-quantity-minus]');
      if (!btn) return;
      var wrap = btn.closest('quantity-selector, [data-quantity-selector], .quantity-selector');
      var input = wrap && wrap.querySelector('[data-quantity-input]');
      if (!input) return;
      e.preventDefault();
      var step = parseInt(input.getAttribute('step'), 10) || parseInt(input.getAttribute('data-increment-value'), 10) || 1;
      var min = parseInt(input.getAttribute('min'), 10) || step || 1;
      var cur = parseInt(input.value, 10);
      if (isNaN(cur)) cur = min;
      var next = btn.hasAttribute('data-quantity-plus') ? cur + step : cur - step;
      if (step > 1) next = Math.round(next / step) * step; // veelvoud van step (per-2)
      if (next < min) next = min;
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      var minusWrap = wrap.querySelector('[data-button-wrapper-minus]');
      if (minusWrap) minusWrap.classList.toggle('quantity-selector__button-wrapper--disabled', next <= min);
    });
  }

  var idField = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');
  var priceEl = root.querySelector('[data-mhp-price]');
  var compareEl = root.querySelector('[data-mhp-compare]');
  var discEl = root.querySelector('[data-mhp-discount]');
  var termijnEl = root.querySelector('[data-mhp-termijn]');
  var delivEl = root.querySelector('[data-mhp-delivery-text]');
  var delivDot = root.querySelector('[data-mhp-delivery-dot]');
  var stockEl = root.querySelector('[data-mhp-stock]');

  function update(id) {
    var key = id != null ? ('' + id) : (idField ? idField.value : null);
    if (!key) return;
    var v = map[key];
    if (!v) return;
    if (priceEl) priceEl.textContent = v.price;
    if (compareEl) {
      if (v.has_compare > 0) { compareEl.textContent = v.compare; compareEl.hidden = false; }
      else { compareEl.hidden = true; }
    }
    if (discEl) {
      if (v.discount > 0) { discEl.textContent = '−' + v.discount + '%'; discEl.hidden = false; }
      else { discEl.hidden = true; }
    }
    if (termijnEl) termijnEl.textContent = v.termijn;
    if (stockEl) stockEl.textContent = v.stock;
    if (delivEl) delivEl.textContent = v.delivery;
    if (delivDot) {
      delivDot.classList.remove('mhp-delivery__dot--soon', 'mhp-delivery__dot--request', 'mhp-delivery__dot--low');
      var ds = v.dot || (v.instock ? 'ok' : 'soon');
      if (ds === 'request') delivDot.classList.add('mhp-delivery__dot--request');
      else if (ds === 'soon') delivDot.classList.add('mhp-delivery__dot--soon');
      else if (ds === 'low') delivDot.classList.add('mhp-delivery__dot--low');
      var dwrap = delivDot.closest('.mhp-delivery'); if (dwrap) dwrap.classList.toggle('mhp-delivery--low', ds === 'low');
    }
    if (typeof mhpSamenstelUpdate === 'function') mhpSamenstelUpdate(key);
  }

  /* ---------- Samengestelde producten (Starfurn): meerprijs-badges + swatch-dots ----------
     Meerprijs = prijs van de variant die je krijgt als je ALLEEN deze optie wisselt,
     minus de huidige variantprijs -> herberekend bij elke variant-change (bv. Ferris:
     pootprijs hangt van de maat af). Draait alleen bij [data-mhp-samenstelling]; anders inert. */
  var mhpSamenstelUpdate = null;
  (function () {
    var ssEl = document.querySelector('[data-mhp-samenstelling]');
    var groups = document.querySelectorAll('[data-mhp-samenstel]');
    if (!ssEl || !groups.length) return;
    var ss = null; try { ss = JSON.parse(ssEl.textContent); } catch (e) { return; }
    var variants = [];
    Object.keys(map).forEach(function (id) { var v = map[id]; if (v && v.opts) variants.push({ opts: v.opts, cents: v.cents }); });
    function money(c) {
      var e = Math.round(c) / 100, whole = Math.floor(e), cents = Math.round((e - whole) * 100);
      var w = ('' + whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return cents === 0 ? w : (w + ',' + (cents < 10 ? '0' + cents : cents));  // hele euro's zonder ,00 (zoals spec: "+ € 119")
    }
    function findCents(opts) {
      for (var i = 0; i < variants.length; i++) {
        var o = variants[i].opts; if (o.length !== opts.length) continue;
        var ok = true; for (var j = 0; j < o.length; j++) { if (o[j] !== opts[j]) { ok = false; break; } }
        if (ok) return variants[i].cents;
      }
      return null;
    }
    function defFor(name) { if (!ss.groepen) return null; name = (name || '').toLowerCase(); for (var i = 0; i < ss.groepen.length; i++) { if ((ss.groepen[i].optie || '').toLowerCase() === name) return ss.groepen[i]; } return null; }
    function swatchFor(def, val) { if (!def || !def.keuzes) return null; for (var i = 0; i < def.keuzes.length; i++) { if ((def.keuzes[i].waarde || '') === val) return def.keuzes[i].swatch || null; } return null; }

    mhpSamenstelUpdate = function (key) {
      var base = map[key]; if (!base || !base.opts) return;
      var baseOpts = base.opts, baseCents = base.cents;
      Array.prototype.forEach.call(groups, function (group) {
        var idx = parseInt(group.getAttribute('data-mhp-samenstel-index'), 10); if (isNaN(idx)) return;
        var def = defFor(group.getAttribute('data-mhp-samenstel'));
        var labels = group.querySelectorAll('.options-selection__option-value');
        Array.prototype.forEach.call(labels, function (lab) {
          var input = lab.querySelector('input'); if (!input) return;
          var val = input.value;
          var nameEl = lab.querySelector('.options-selection__option-value-name') || lab;
          // swatch-dot (eenmalig injecteren)
          var hex = swatchFor(def, val);
          if (hex && !lab.querySelector('.mhp-ss-dot')) {
            var dot = document.createElement('span'); dot.className = 'mhp-ss-dot'; dot.style.background = hex;
            nameEl.insertBefore(dot, nameEl.firstChild);
          }
          // meerprijs-badge (relatief aan huidige selectie)
          var trial = baseOpts.slice(); trial[idx] = val;
          var c = findCents(trial);
          var badge = lab.querySelector('.mhp-ss-badge');
          if (!badge) { badge = document.createElement('span'); badge.className = 'mhp-ss-badge'; nameEl.appendChild(badge); }
          if (c == null) { badge.hidden = true; return; }
          var diff = c - baseCents;
          if (diff > 0) { badge.textContent = '+ € ' + money(diff); badge.hidden = false; }
          else if (diff < 0) { badge.textContent = '− € ' + money(-diff); badge.hidden = false; }
          else { badge.textContent = ''; badge.hidden = true; }
        });
      });
    };
    var initId = idField ? idField.value : null;
    if (initId) mhpSamenstelUpdate(initId);
  })();

  // Empire's <variant-selection> dispatcht een 'variant-change' CustomEvent (geen native change).
  var vsel = document.querySelector('[data-variant-selection]');
  // Na een korte init-venster: bij variantwissel op mobiel naar boven scrollen,
  // zodat de gebruiker meteen de foto's van de gekozen variant ziet.
  var mhpScrollReady = false;
  setTimeout(function () { mhpScrollReady = true; }, 900);
  if (vsel) {
    vsel.addEventListener('variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) update(v.id);
      if (mhpScrollReady && window.matchMedia('(max-width: 989px)').matches) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    });
  }
  // Fallback: native change op het id-veld.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'id') update();
  });

  // ===== Variant-galerij: swipe-carousel met eigen foto's per variant =====
  // Alle foto's van de variant staan als slides in één track (vooraf geladen via
  // srcset -> snel, geen laad-hapering bij swipe). Mobiel: finger-follow drag die
  // de foto met je vinger meebeweegt en op release doorschuift/terugveert. Desktop:
  // pijltjes. Clones voor/achter = naadloze loop (laatste -> eerste zonder sprong).
  var mhvg = document.querySelector('[data-mhvg]');
  if (mhvg) {
    var vmap = {};
    try { vmap = JSON.parse(mhvg.querySelector('[data-mhvg-map]').textContent); } catch (e) {}
    var mhvgThumbs = mhvg.querySelector('[data-mhvg-thumbs]');
    var mhvgView = mhvg.querySelector('[data-mhvg-main]');   // overflow-viewport
    var mhvgTrack = mhvg.querySelector('[data-mhvg-track]');
    var VG_SIZES = '(max-width: 749px) 100vw, 600px';
    var VG_DUR = 300;                         // snap-animatie (ms)
    var vgN = 0, vgPhys = 0, vgW = 0, vgPending = null;

    function vgEsc(s) { return ('' + (s == null ? '' : s)).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
    function vgMeasure() { var r = mhvgView.getBoundingClientRect(); vgW = r.width || mhvgView.clientWidth || 0; }
    function vgSetX(px, animate) {
      mhvgTrack.style.transition = animate ? ('transform ' + VG_DUR + 'ms cubic-bezier(.22,.61,.36,1)') : 'none';
      mhvgTrack.style.transform = 'translate3d(' + px + 'px,0,0)';
    }
    function vgPlace(animate) { vgSetX(-vgPhys * vgW, animate); }
    // physical index -> echte foto-index (0 = clone van laatste, vgN+1 = clone van eerste)
    function vgReal(p) { if (p === 0) return vgN - 1; if (p === vgN + 1) return 0; return p - 1; }
    function vgSyncThumbs(real) {
      var btns = mhvgThumbs.querySelectorAll('.mhvg__thumb');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('is-active', i === real);
      var act = btns[real];
      if (act && act.scrollIntoView) act.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    // Rond een lopende clone-reset direct af (bij interruptie/nieuwe actie).
    function vgSettle() {
      if (!vgPending) return;
      clearTimeout(vgPending); vgPending = null;
      if (vgPhys === 0) vgPhys = vgN; else if (vgPhys === vgN + 1) vgPhys = 1;
      vgPlace(false);
    }
    // Eén stap: dir=+1 volgende, -1 vorige. Animeert; springt daarna onzichtbaar
    // terug van de clone naar het echte slide -> naadloze loop.
    function vgGo(dir) {
      if (vgN < 2) return;
      vgSettle();
      vgPhys += dir;
      vgPlace(true);
      vgSyncThumbs(vgReal(vgPhys));
      if (vgPhys === 0 || vgPhys === vgN + 1) {
        vgPending = setTimeout(function () {
          vgPending = null;
          vgPhys = (vgPhys === 0) ? vgN : 1;
          vgPlace(false);
        }, VG_DUR + 30);
      }
    }
    // Directe sprong naar foto (thumbnail-klik).
    function vgJump(real) {
      if (vgN < 2) { return; }
      vgSettle();
      vgPhys = real + 1;
      vgPlace(true);
      vgSyncThumbs(real);
    }
    // Bouw de track (met clones) + thumbs voor een variant.
    function vgBuild(vid) {
      var imgs = vmap['' + vid];
      if (!imgs || !imgs.length) return;
      mhvg.setAttribute('data-mhvg-sel', vid); // houd de selectie in sync -> lightbox toont de foto's van de GEKOZEN variant, niet de eerste
      vgN = imgs.length;
      mhvgThumbs.innerHTML = imgs.map(function (im, i) {
        return '<button type="button" class="mhvg__thumb" data-mhvg-thumb aria-label="Foto ' + (i + 1) + '">' +
          '<img src="' + im.t + '" alt="" loading="lazy" width="76" height="76"></button>';
      }).join('');
      function slide(im) {
        return '<div class="mhvg__slide"><img src="' + im.f + '" srcset="' + im.ss + '" sizes="' + VG_SIZES +
          '" alt="' + vgEsc(im.a) + '" width="800" height="800" draggable="false"></div>';
      }
      var html = '';
      if (vgN > 1) html += slide(imgs[vgN - 1]);   // leading clone (= laatste)
      html += imgs.map(slide).join('');
      if (vgN > 1) html += slide(imgs[0]);         // trailing clone (= eerste)
      mhvgTrack.innerHTML = html;
      vgMeasure();
      vgPhys = (vgN > 1) ? 1 : 0;
      vgPlace(false);
      vgSyncThumbs(0);
      if (!vgW) requestAnimationFrame(function () { vgMeasure(); vgPlace(false); });
    }

    // thumbnail-klik
    mhvgThumbs.addEventListener('click', function (e) {
      var t = e.target.closest('[data-mhvg-thumb]'); if (!t) return;
      var btns = [].slice.call(mhvgThumbs.querySelectorAll('.mhvg__thumb'));
      var i = btns.indexOf(t); if (i >= 0) vgJump(i);
    });
    // pijltjes (desktop)
    var vgPrev = mhvg.querySelector('[data-mhvg-prev]');
    var vgNext = mhvg.querySelector('[data-mhvg-next]');
    if (vgPrev) vgPrev.addEventListener('click', function () { vgGo(-1); });
    if (vgNext) vgNext.addEventListener('click', function () { vgGo(1); });

    // swipe (finger-follow): de track beweegt live met de vinger mee.
    var vgDrag = false, vgSX = 0, vgSY = 0, vgBase = 0, vgDecided = false, vgHoriz = false;
    mhvgView.addEventListener('touchstart', function (e) {
      if (vgN < 2) return;
      vgSettle(); vgMeasure();
      vgDrag = true; vgDecided = false; vgHoriz = false;
      var t = e.touches[0]; vgSX = t.clientX; vgSY = t.clientY;
      vgBase = -vgPhys * vgW;
      vgSetX(vgBase, false);
    }, { passive: true });
    mhvgView.addEventListener('touchmove', function (e) {
      if (!vgDrag) return;
      var t = e.touches[0];
      var dx = t.clientX - vgSX, dy = t.clientY - vgSY;
      if (!vgDecided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        vgDecided = true; vgHoriz = Math.abs(dx) > Math.abs(dy);
      }
      if (!vgHoriz) return;            // verticaal: laat de pagina scrollen
      e.preventDefault();
      if (dx > vgW) dx = vgW; else if (dx < -vgW) dx = -vgW;
      vgSetX(vgBase + dx, false);
    }, { passive: false });
    function vgEnd(e) {
      if (!vgDrag) return; vgDrag = false;
      if (!vgHoriz) return;
      var t = (e.changedTouches && e.changedTouches[0]) || null;
      var dx = t ? (t.clientX - vgSX) : 0;
      var thresh = Math.min(60, vgW * 0.18);
      if (dx <= -thresh) vgGo(1);
      else if (dx >= thresh) vgGo(-1);
      else vgPlace(true);             // te klein: terugveren
    }
    mhvgView.addEventListener('touchend', vgEnd, { passive: true });
    mhvgView.addEventListener('touchcancel', vgEnd, { passive: true });

    // resize -> slidebreedte herberekenen
    var vgRT;
    window.addEventListener('resize', function () {
      clearTimeout(vgRT);
      vgRT = setTimeout(function () { vgSettle(); vgMeasure(); vgPlace(false); }, 120);
    });

    // variantwissel -> foto-set van die variant (reset naar eerste)
    if (vsel) {
      vsel.addEventListener('variant-change', function (e) {
        try { var v = e.detail && e.detail.variant; if (v && v.id) vgBuild(v.id); } catch (err) {}
      });
    }
    // init
    try { vgBuild(mhvg.getAttribute('data-mhvg-sel')); } catch (err) {}
  }

  // Vertrouwensbadge -> smooth scroll naar social proof.
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-mhp-scrollto]');
    if (t) {
      var target = document.querySelector(t.getAttribute('data-mhp-scrollto'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      return;
    }
    // Omschrijving "Lees meer"
    var more = e.target.closest('[data-mhp-desc-toggle]');
    if (more) {
      var body = document.querySelector('[data-mhp-desc]');
      if (body) {
        var clamped = body.classList.toggle('is-clamped');
        more.firstChild.textContent = clamped ? 'Lees meer ' : 'Lees minder ';
        more.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      }
    }
  });

  // Aantal-stepper: NIET meer zelf binden. Sinds we [data-product-form-area]
  // toevoegden (voor de variant-fotoswap) initialiseert Empire's ProductDetails
  // volledig en beheert Empire's eigen <quantity-selector> de +/- (respecteert
  // min/step/max + minus-disable). Een eigen stepper hier gaf een DUBBELE binding
  // -> elke klik telde 2x de step (bij per-2 stoelen: 2->6->10). Empire doet 't nu.

  // "Maak het compleet" — voegt huidig product + de 2 complementen in één keer toe.
  // Via de cart-drawer-API (window.MHCartDrawer.addItems) -> zelfde sections-flow
  // als de gewone add-to-cart, dus verse drawer-HTML direct (geen refresh-race).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mh-bundle-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var form = document.querySelector('[data-product-form], form[action*="/cart/add"]');
    var idField = form && form.querySelector('[name="id"]');
    var qtyInput = form && form.querySelector('[data-quantity-input], [name="quantity"]');
    var items = [];
    var bundle = btn.closest('[data-mhp-bundle]');
    if (bundle) {
      // vinkjes bepalen wat er mee gaat; het huidige product volgt de gekozen variant en hoeveelheid
      [].forEach.call(bundle.querySelectorAll('[data-bundle-cb]'), function (cb) {
        if (!cb.checked) return;
        if (cb.hasAttribute('data-bundle-current')) {
          if (idField && idField.value && idField.value !== 'not-selected') {
            items.push({ id: Number(idField.value), quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1 });
          }
        } else {
          var vid = cb.getAttribute('data-variant');
          if (vid) items.push({ id: Number(vid), quantity: parseInt(cb.getAttribute('data-qty'), 10) || 1 });
        }
      });
    } else {
      // huidig product — respecteer de gekozen hoeveelheid (dus ook per-2)
      if (idField && idField.value && idField.value !== 'not-selected') {
        items.push({ id: Number(idField.value), quantity: (qtyInput && parseInt(qtyInput.value, 10)) || 1 });
      }
      // complementen — "id:qty,id:qty" (qty = 2 voor per-2 producten)
      (btn.getAttribute('data-variants') || '').split(',').forEach(function (pair) {
        pair = pair.trim(); if (!pair) return;
        var p = pair.split(':');
        var id = (p[0] || '').trim();
        if (id) items.push({ id: Number(id), quantity: parseInt(p[1], 10) || 1 });
      });
    }
    if (!items.length) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Toevoegen…';
    function done() { btn.textContent = 'Toegevoegd ✓'; }
    function fail() { btn.disabled = false; btn.textContent = orig; }
    if (window.MHCartDrawer && window.MHCartDrawer.addItems) {
      window.MHCartDrawer.addItems(items).then(done, fail);
    } else {
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); var o = document.querySelector('[data-cart-drawer-open], .site-header-cart--button'); if (o) { o.click(); } else { window.location = '/cart'; } done(); })
        .catch(fail);
    }
  });
})();


/* ==================================================================================================
   PDP v2 (13-10-2026): specificaties open op desktop, "Maak het compleet" met vinkjes, geen dubbele
   producten in de rijen onderaan, sticky koopbalk op desktop, fototeller op mobiel.
   ================================================================================================== */
(function () {
  'use strict';
  var root = document.querySelector('[data-mhp]');
  if (!root) return;
  var desk = window.matchMedia('(min-width: 990px)');

  /* ---------- Specificaties: op desktop altijd open (kop zonder pijltje), op mobiel inklapbaar ---------- */
  var specs = document.querySelector('[data-mhp-specs]');
  function specsSync() {
    if (!specs) return;
    if (desk.matches) { specs.setAttribute('open', ''); specs.setAttribute('data-desk-open', ''); }
    else if (specs.hasAttribute('data-desk-open')) { specs.removeAttribute('open'); specs.removeAttribute('data-desk-open'); }
  }
  if (specs) {
    specsSync();
    (desk.addEventListener ? desk.addEventListener('change', specsSync) : desk.addListener(specsSync));
    specs.addEventListener('toggle', function () { if (desk.matches && !specs.open) specs.setAttribute('open', ''); });
  }

  /* ---------- Maak het compleet: vinkjes -> totaal en knoptekst ---------- */
  var bundle = document.querySelector('[data-mhp-bundle]');
  function money(c) {
    var w = Math.floor(c / 100), r = c % 100;
    var ws = ('' + w).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return ws + (r === 0 ? ',-' : (',' + (r < 10 ? '0' + r : r)));
  }
  function bundleSync() {
    if (!bundle) return;
    var cbs = [].slice.call(bundle.querySelectorAll('[data-bundle-cb]'));
    var n = 0, sum = 0;
    cbs.forEach(function (cb) {
      if (!cb.checked) return;
      n++; sum += (parseInt(cb.getAttribute('data-cents'), 10) || 0) * (parseInt(cb.getAttribute('data-qty'), 10) || 1);
    });
    var label = bundle.querySelector('[data-bundle-label]'), sumEl = bundle.querySelector('[data-bundle-sum]'), btn = bundle.querySelector('[data-mh-bundle-add]');
    if (label) label.textContent = n ? ('Totaal voor ' + n + (n === 1 ? ' product' : ' producten')) : 'Kies minstens één product';
    if (sumEl) sumEl.textContent = n ? money(sum) : '';
    if (btn && !btn.getAttribute('data-done')) {
      btn.disabled = n === 0;
      btn.textContent = n === 0 ? '+ Voeg toe' : (n === 1 ? '+ Voeg toe' : '+ Voeg alle ' + n + ' toe');
    }
  }
  if (bundle) bundle.addEventListener('change', function (e) { if (e.target && e.target.hasAttribute('data-bundle-cb')) bundleSync(); });

  /* ---------- geen product dubbel: Bekijk ook eens en Onlangs bekeken sluiten uit wat er al staat ---------- */
  function handleOf(el) {
    var a = el.matches && el.matches('a[href*="/products/"]') ? el : el.querySelector('a[href*="/products/"]');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  var curHandle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || null;
  var shown = {};
  if (curHandle) shown[curHandle] = true;
  if (bundle) [].forEach.call(bundle.querySelectorAll('a[href*="/products/"]'), function (a) { var h = handleOf(a); if (h) shown[h] = true; });

  var recsSeen = {};
  function dedupe(container, section, isRecs) {
    if (!container || !section) return;
    if (container.textContent.trim() === '[object Object]') { container.innerHTML = ''; section.style.display = 'none'; return; }
    var cards = [].slice.call(container.querySelectorAll('.pc, .productitem, [data-product-card]'));
    if (!cards.length) return;
    var left = 0;
    cards.forEach(function (c) {
      var h = handleOf(c);
      // Bekijk ook eens: sluit alleen het huidige product en de bundel uit. Onlangs bekeken: ook alles uit Bekijk ook eens.
      var dup = h && (shown[h] || (!isRecs && recsSeen[h]));
      if (dup) { c.style.display = 'none'; c.setAttribute('data-mhp-dup', ''); }
      else { c.style.display = ''; left++; if (h && isRecs) recsSeen[h] = true; }
    });
    section.style.display = left ? '' : 'none';
  }
  function watch(section, record) {
    if (!section) return;
    var run = function () { dedupe(section, section, !!record); };
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 60); });
    mo.observe(section, { childList: true, subtree: true });
    run();
  }
  var recs = document.querySelector('.product-recommendations--section');
  var rec2 = recs && recs.querySelector('[data-product-recommendations]');
  if (rec2) {
    var tr;
    new MutationObserver(function () { clearTimeout(tr); tr = setTimeout(function () { dedupe(rec2, recs, true); }, 60); }).observe(rec2, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { dedupe(rec2, recs, true); }, 600);
  }
  var rv = document.querySelector('.product-recently-viewed--section');
  if (rv) {
    var trv;
    new MutationObserver(function () { clearTimeout(trv); trv = setTimeout(function () { dedupe(rv, rv, false); }, 80); }).observe(rv, { childList: true, subtree: true });
  }

  /* ---------- sticky koopbalk op desktop ---------- */
  var bar = document.querySelector('[data-cro-stickybar]');
  var atc = document.querySelector('.product-form--atc-button');
  if (bar && atc && 'IntersectionObserver' in window) {
    var mapEl = document.querySelector('[data-mhp-variants]'), satcEl = document.querySelector('[data-mh-satc-variants]');
    var vmap = {}, smap = {};
    try { vmap = JSON.parse(mapEl.textContent); } catch (e) {}
    try { smap = JSON.parse(satcEl.textContent); } catch (e) {}
    var imgEl = bar.querySelector('[data-sb-img]'), varEl = bar.querySelector('[data-sb-variant]'), prEl = bar.querySelector('[data-sb-price]'),
        wasEl = bar.querySelector('[data-sb-was]'), disEl = bar.querySelector('[data-sb-disc]'), addEl = bar.querySelector('[data-sb-add]');
    var idField = document.querySelector('[data-product-form] [name="id"], form[action*="/cart/add"] [name="id"]');
    function sbSync(id) {
      var key = id != null ? ('' + id) : (idField ? idField.value : null);
      var v = vmap[key], s = smap[key];
      if (v) {
        if (prEl) prEl.textContent = v.price;
        if (wasEl) { if (v.has_compare > 0) { wasEl.textContent = v.compare; wasEl.hidden = false; } else wasEl.hidden = true; }
        if (disEl) { if (v.discount > 0) { disEl.textContent = '\u2212' + v.discount + '%'; disEl.hidden = false; } else disEl.hidden = true; }
      }
      if (s) {
        if (imgEl && s.image) imgEl.src = s.image;
        if (varEl) varEl.textContent = ('' + (s.title || '')).split(' / ').filter(function (x) { return x !== 'Geen'; }).join(' \u00b7 ');
      }
    }
    var vs = document.querySelector('[data-variant-selection]');
    if (vs) vs.addEventListener('variant-change', function (e) { var v = e.detail && e.detail.variant; if (v && v.id) sbSync(v.id); });
    document.addEventListener('change', function (e) { if (e.target && e.target.name === 'id') sbSync(); });
    if (addEl) addEl.addEventListener('click', function () { if (!atc.disabled) atc.click(); });
    // bovenkant van de vaste balk = onderkant van wat er bovenin vast staat (USP-balk en eventueel header)
    function barTop() {
      var top = 0;
      [].forEach.call(document.querySelectorAll('.cro-usp, .cro-usp-bar, .site-header, header[role="banner"]'), function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'sticky' || cs.position === 'fixed') { var r = el.getBoundingClientRect(); if (r.height > 0 && r.top <= 1) top = Math.max(top, Math.round(r.bottom)); }
      });
      bar.style.setProperty('--mhp-bar-top', top + 'px');
    }
    var on = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var show = !en.isIntersecting && en.boundingClientRect.top < 100 && desk.matches;   // voorbij gescrold (niet: nog onder in beeld)
        if (show !== on) { on = show; if (show) { barTop(); bar.removeAttribute('hidden'); } else bar.setAttribute('hidden', ''); }
      });
    }, { rootMargin: '-90px 0px 0px 0px' });
    io.observe(atc);
    window.addEventListener('scroll', function () { if (on) barTop(); }, { passive: true });
  }

  bundleSync();
})();

/* PDP v2: fototeller "1 / 6" op mobiel (de thumbnailstrip is daar weg; swipen wisselt de foto) */
(function () {
  'use strict';
  var root = document.querySelector('[data-mhp]');
  if (!root) return;
  var host = document.querySelector('.mhp--v2 .product-gallery--viewer') || document.querySelector('.mhp--v2 .mhvg__main');
  if (!host) return;
  var isPg = host.classList.contains('product-gallery--viewer');
  var el = document.createElement('span');
  el.className = 'mhp-gcount';
  el.setAttribute('aria-live', 'polite');
  el.hidden = true;
  host.appendChild(el);
  function thumbs() { return [].slice.call(document.querySelectorAll(isPg ? '.mhp--v2 .product-gallery--media-thumbnail' : '.mhp--v2 .mhvg__thumb')); }
  function render() {
    var t = thumbs();
    if (t.length < 2) { el.hidden = true; return; }
    var cur = 0;
    t.forEach(function (b, i) {
      if (isPg ? b.getAttribute('data-gallery-selected') === 'true' : b.classList.contains('is-active')) cur = i;
    });
    el.textContent = (cur + 1) + ' / ' + t.length;
    el.hidden = false;
  }
  var tc = document.querySelector(isPg ? '.mhp--v2 .gallery-navigation--scroller, .mhp--v2 .product-gallery--navigation' : '.mhp--v2 [data-mhvg-thumbs]');
  var timer;
  var mo = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(render, 30); });
  if (tc) mo.observe(tc, { attributes: true, childList: true, subtree: true, attributeFilter: ['data-gallery-selected', 'class'] });
  render();
  setTimeout(render, 800);
})();
